
/* Script to show fixed navbar */
(function () {

  var navbar = document.querySelector('.site-header');
  var _window = window;

  var scrollListener = function (event) {

    if (window.screen.availWidth < 600) {
      var offset = 80;
    } else{
      var offset = 100;
    }

    if ( navbar.classList.contains('inverted') && _window.scrollY > offset ) {
      navbar.classList.remove('inverted');
    }
    else if ( ! navbar.classList.contains('inverted') && _window.scrollY < offset ) {
      navbar.classList.add('inverted');
    }

  };

  _window.addEventListener('scroll', scrollListener);

})();
